import tw, { styled } from "twin.macro";

export const StyledWrapperGradient = styled.div`
  ${tw`bg-gradient-purple w-full rounded-[0.75rem] p-m flex flex-col relative gap-m h-full my-ml overflow-hidden
    min-[700px]:(flex-row justify-between)
    medium:(p-8 rounded-xl my-l)
    large:(px-10 rounded-xxl my-xl)
  `}

  & .SellWithUsBanner-title {
    ${tw`text-primaryV2-100`}
  }

  & .SellWithUsBanner-text {
    ${tw`text-primaryV2-100`}
  }

  & > div {
    ${tw`flex flex-col w-full medium:(gap-m w-[33.0625rem])`}
    & > div {
      ${tw`flex flex-col gap-m`}
    }
    & > a {
      ${tw`w-max mt-8 medium:(mt-0)`}

      & > span {
        ${tw`font-semibold`}
      }
    }
  }

  & > figure {
    ${tw`relative w-full min-[700px]:(w-[22.6875rem])`}

    & > img {
      ${tw`absolute bottom-[-2rem] right-0 h-[80px] w-auto
      medium:(h-[8rem] bottom-[-4rem])
      min-[700px]:(h-[13rem] bottom-[-6rem])
      min-[720px]:(h-[14rem] )
      large:(h-[17rem])
    `}
    }
  }
`;
